import moment from 'moment';
import React, { FC, useState } from 'react';

import { getOfferReportDownload } from '../../../services/TenantReports/OfferReport.service';
import usePagination from '../../../shared/hooks/usePagination';
import OfferFilter from './Filter';
import { OfferReportFilter } from './FilterType';
import OfferDownloadTable from './List';

export const GroupingColumn = {
  RFM: 'RFM',
  Tier: 'Tier'
};

const offerInitialState: OfferReportFilter = {
  startDate: moment()
    .subtract(1, 'month')
    .format('YYYY-MM-DD'),
  endDate: moment().format('YYYY-MM-DD'),
  businessId: undefined,
  segment: GroupingColumn.RFM
};

const OfferTenantReport: FC = () => {
  const [refreshView, setRefreshView] = useState<string>('');
  const [filters, setFilters] = useState<OfferReportFilter>(offerInitialState);
  const { data, isLoading, page, offset, setPage, setOffset } = usePagination(
    getOfferReportDownload,
    [refreshView],
    filters.segment
  );
  return (
    <div style={{ padding: '2rem' }}>
      <div>
        <h4>Offer Report</h4>
      </div>
      <OfferFilter
        setRefreshView={setRefreshView}
        filters={filters}
        setFilters={setFilters}
      />
      <OfferDownloadTable
        reports={data || []}
        isLoading={isLoading}
        page={page}
        offset={offset}
        setPage={setPage}
        setOffset={setOffset}
      />
    </div>
  );
};

export default OfferTenantReport;
